import ApiBase from './Api'
import { ScrapeEntity } from 'types/ScrapeEntity'

const SCRAPE_API_PATHS = {
    SCRAPE: '/admin/scraping',
}

class ScrapeApi extends ApiBase {
    async read(url: string): Promise<ScrapeEntity> {
        const response = await this._getRequest(SCRAPE_API_PATHS.SCRAPE, { queryParameters: { url } })

        return response
    }
}

export default ScrapeApi
